import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const Skeleton = ({
  width = 'w-full',
  height = 'h-4',
  rounded = 'rounded-md',
  className = '',
}) => {
  return (
    <div
      className={clsx(
        'animate-pulse bg-white/10 dark:bg-white/5 backdrop-blur-md',
        width,
        height,
        rounded,
        className
      )}
    />
  );
};

Skeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  rounded: PropTypes.string,
  className: PropTypes.string,
};
